<template>
  <div class="list-section">
    <!-- 搜索区域 -->
    <div class="search-bg">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item :label="$t('proxy.text88') + '：'" class="search-label">
            <el-input v-model="filters.customerName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="agentConfig.phoneLoginReg">
          <el-form-item
            :label="$t('followOrder.text6') + '：'"
            class="search-label"
          >
            <el-input v-model="filters.phone" placeholder=""></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$t('followOrder.text7') + '：'"
            class="search-label"
          >
            <el-input v-model="filters.fundAccountId" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$t('followOrder.text35') + '：'"
            class="search-label"
          >
            <el-autocomplete
              v-model="filters.symbol"
              :fetch-suggestions="fetchSymbolSuggestions"
              placeholder=""
              clearable
            >
              <template #default="{ item }">
                <div class="name">{{ item.value }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$t('followOrder.text42') + '：'"
            class="search-label"
          >
            <el-select v-model="filters.tradeStatus" placeholder="">
              <el-option
                :label="$t('followOrder.text64')"
                :value="0"
              ></el-option>
              <el-option
                :label="$t('followOrder.text63')"
                :value="1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第二行 -->
      <el-row :gutter="20" style="margin-top: 10px">
        <el-col :span="4" v-if="agentConfig.emailLoginReg">
          <el-form-item :label="$t('proxy.text34') + '：'" class="search-label">
            <el-input v-model="filters.email" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$t('followOrder.text37') + '：'"
            class="search-label"
          >
            <el-select v-model="filters.bsType" placeholder="">
              <el-option
                :label="$t('followOrder.text38')"
                :value="1"
              ></el-option>
              <el-option
                :label="$t('followOrder.text39')"
                :value="2"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$t('followOrder.text49') + '：'"
            class="search-label"
          >
            <el-date-picker
              v-model="filters.firstTradingTimeRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('proxy.text201')"
              :end-placeholder="$t('proxy.text202')"
              placeholder=""
              format="MM/DD/YYYY"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$t('followOrder.text67') + '：'"
            class="search-label"
          >
            <el-date-picker
              v-model="filters.lastTradingTimeRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('proxy.text201')"
              :end-placeholder="$t('proxy.text202')"
              placeholder=""
              format="MM/DD/YYYY"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            @click="handleSearch"
            class="search-button"
            >{{ $t("proxy.text13") }}</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="list-spacer"></div>

    <!-- 表格列表 -->
    <div class="table-container">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column
          min-width="100px"
          prop="userId"
          :label="$t('proxy.text84')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="130px"
          prop="customerName"
          :label="$t('proxy.text88')"
          align="center"
        />
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          min-width="100px"
          prop="phone"
          :label="$t('followOrder.text6')"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.phone === "" ? "--" : scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          min-width="130px"
          prop="email"
          :label="$t('proxy.text34')"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.email === "" ? "--" : scope.row.email }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="130px"
          prop="webAccountName"
          :label="$t('followOrder.text7')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="openOrderNo"
          :label="$t('followOrder.text127')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="symbol"
          :label="$t('followOrder.text35')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="bsTypeDesc"
          :label="$t('followOrder.text37')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="quantity"
          :label="$t('followOrder.text11')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="tradeStatus"
          :label="$t('followOrder.text42')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="openPrice"
          :label="$t('followOrder.text50')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="closePriceDesc"
          :label="$t('followOrder.text68')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="closeTypeDesc"
          :label="$t('followOrder.text58')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="stopLossDesc"
          :label="$t('proxy.text224')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="stopProfitDesc"
          :label="$t('proxy.text223')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="profitDesc"
          :label="$t('followOrder.text69')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="overNightInterestDesc"
          :label="$t('followOrder.text54')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="marginRate"
          :label="$t('followOrder.text55')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="firstTradingTime"
          :label="$t('followOrder.text49')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="lastTradingTimeDesc"
          :label="$t('followOrder.text67')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="[10, 50, 100, 200]"
        :disabled="false"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import apiService from "@/api/request";

export default {
  setup() {
    const loading = ref(false);
    const store = useStore();
    const agentConfig = computed(() => store.getters.getAgentConfig);
    const filters = reactive({
      customerName: "",
      phone: "",
      fundAccountId: "",
      symbol: "",
      bsType: "",
      tradeStatus: "",
      firstTradingTimeRange: [],
      lastTradingTimeRange: [],
      email: "",
    });

    const symbolList = ref([]); // 存储交易品种数据
    const pagination = reactive({
      currentPage: 1,
      pageSize: 10,
      total: 0,
    });

    const tableData = ref([]);

    // 获取交易品种数据
    const fetchSymbols = async () => {
      try {
        const response = await apiService.proxyGetSymbols();
        if (response.status === 1) {
          symbolList.value = response.data.list;
        } else {
          console.error("获取交易品种失败:", response.message);
        }
      } catch (error) {
        console.error("获取交易品种失败:", error);
      }
    };

    // 动态生成交易品种的匹配选项
    const fetchSymbolSuggestions = (queryString, cb) => {
      if (!queryString) {
        // 将 symbolList 转换为包含 `value` 字段的对象数组
        cb(symbolList.value.map((symbol) => ({ value: symbol })));
        return;
      }
      const results = symbolList.value
        .filter((symbol) =>
          symbol.toLowerCase().includes(queryString.toLowerCase())
        )
        .map((symbol) => ({ value: symbol })); // 确保每个选项是一个包含 `value` 属性的对象
      cb(results);
    };

    const fetchData = async () => {
      loading.value = true;
      try {
        const params = {
          userToken:
            store.getters.userToken !== "" ? store.getters.userToken : "x",
          page: pagination.currentPage,
          limit: pagination.pageSize,
          customerName: filters.customerName,
          phone: filters.phone,
          email: filters.email,
          fundAccountId: filters.fundAccountId,
          symbol: filters.symbol,
          bsType: filters.bsType,
          tradeStatus: filters.tradeStatus,
          firstTradingTimeStart: filters.firstTradingTimeRange
            ? filters.firstTradingTimeRange.length
              ? filters.firstTradingTimeRange[0]
              : ""
            : "",
          firstTradingTimeEnd: filters.firstTradingTimeRange
            ? filters.firstTradingTimeRange.length
              ? filters.firstTradingTimeRange[1]
              : ""
            : "",
          lastTradingTimeStart: filters.lastTradingTimeRange
            ? filters.lastTradingTimeRange.length
              ? filters.lastTradingTimeRange[0]
              : ""
            : "",
          lastTradingTimeEnd: filters.lastTradingTimeRange
            ? filters.lastTradingTimeRange.length
              ? filters.lastTradingTimeRange[1]
              : ""
            : "",
        };

        const response = await apiService.tradingTransactionRecordList(params);
        const { tradingTransactionRecords, count } = response.data;
        tableData.value = tradingTransactionRecords;
        pagination.total = count;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.currentPage = 1;
      fetchData();
    };

    const handleSizeChange = (val) => {
      pagination.pageSize = val;
      fetchData();
    };

    const handleCurrentChange = (val) => {
      pagination.currentPage = val;
      fetchData();
    };

    onMounted(() => {
      fetchSymbols(); // 加载交易品种数据
      fetchData(); // 加载表格数据
    });

    const formatCell = (row, column, cellValue, index) => {
      return cellValue === "" || cellValue === null ? "--" : cellValue;
    };

    return {
      loading,
      filters,
      pagination,
      symbolList, // 绑定交易品种数据
      tableData,
      handleSearch,
      handleSizeChange,
      handleCurrentChange,
      formatCell,
      fetchSymbolSuggestions,
      agentConfig,
    };
  },
};
</script>

<style lang="less" scoped>
</style>
